import { ua, UAType } from './tools/ua';
import { weappSDK, needConvertWechatData } from './tools/sdk';
import history, { historyUtil } from './tools/history-plugin/history';
import documentTitle from './tools/document-title';
import replaceCss from './tools/replaceCss';
import setTheme, { updateFavIcon, initPageGrey, removeHtmlLang, setFontSize, removeLinkIcon } from './tools/theme';
import vconsole from './tools/vconsole';
import ALink, { ALinkIntercept } from './tools/a-link';
import weappMonitorInstance from './tools/monitor';
import './tools/history-plugin/wea_link_keep';
import { secondDomainAndPath } from './tools/react-plugin/second-domain';
import { needRTL, setRTL } from './tools/locale/rtl';
import { registerSdkpen } from './tools/open/registerSdkpen';
import { translateOpen } from './tools/trans-open/index'
import sparkMD5 from './tools/spark-md5';
import { successBatchTip, failureBatchTip, registerTip } from './tools/tip'
import dayjsPolyfill from './tools/dayjs/polyfill';
import './tools/three-party-sdk';
import './tools/ie-polyfill';
import { handleWeChatJs } from './tools/wechat-jssdk';
// import './tools/prefetch'; // 处理公共prefetch模块

// 设置文本书写方向
needRTL() && setRTL();

const setTitle = documentTitle.setTitle.bind(documentTitle);


// 处理二级路径和二级域名
secondDomainAndPath();

// 处理e9地址转换方法
translateOpen();

// 解决IE低版本浏览器不支持location对象的origin属性

try {
  if (!window.location.origin) {
    const { protocol, hostname, port } = window.location;
    const origin = `${protocol}//${hostname}${port ? ':' + port : ''}`;
    // @ts-ignore 只读属性，无法赋值所以ignore
    window.location.origin = origin;
  }
} catch (error) {
  console.error(error)
}
// 解决低版本浏览器使用 dayjs 时 Intl 对象不兼容问题
dayjsPolyfill();

if (/wea_link_keep_vconsole/.test(window.location.href)) {
  vconsole().then(m => new m.default());
}

// 设置主题
setTheme(ua.device !== 'PC');

// favicon全局配置化
const defaultFavIcon = window.TEAMS?.deploy === 'private' ? '/static/img/global/ecology-favicon.ico' : '/static/img/global/favicon.ico';
if (window?.TEAMS?.ready && typeof window.TEAMS.ready === 'function') {
  window.TEAMS.ready('tenantLogo', {
    success: (data: any) => {
      updateFavIcon();
    },
    failed: (data: any) => {
      updateFavIcon(defaultFavIcon);
    },
  })
} else {
  updateFavIcon(defaultFavIcon);
}



// 处理本地化应用安装
removeLinkIcon();

// 加上兼容处理，只有在TEAMS需要置灰有效果的时候,才默认调用方法。
if (window.TEAMS?.greyInfo?.mainPageGreyStatus) {
  initPageGrey();
}
// no.2691739 解决系统内html标签携带lang属性(默认去掉)的问题
removeHtmlLang();

// 企业微信相关JS注入的逻辑处理, 按需执行
if (ua.browser === 'wxwork' || window?.TEAMS?.loginChannel === 'ebridge_wework') {
  handleWeChatJs()
}

// 统一h5 禁止缩放
if (ua.device !== 'PC') {
  const content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=0';
  const metaNode = document.querySelector('meta[name =viewport]');
  if (metaNode) {
    metaNode.setAttribute('content', content);
  }
  else {
    const meta = document.createElement('meta');
    meta.content = content;
    meta.name = 'viewport';
    document.getElementsByTagName('head')[0].appendChild(meta);
  }
}

let unRegisterLarkOpen = null;
if (/Lark/.test(ua.browser)) {
  unRegisterLarkOpen = registerSdkpen();
}

let unRegisterDingTalkOpen = null;
if (/DingTalk/.test(ua.browser)) {
  unRegisterDingTalkOpen = registerSdkpen();
}

let unRegisterYunZhiJiaOpen = null;
if (/YunZhiJia/.test(ua.browser) && ua.device === 'PC') {
  unRegisterYunZhiJiaOpen = registerSdkpen();
}

if (/wxwork|MicroMessenger|DingTalk|ZhengWuDing|Welink|YunZhiJia|Lark/.test(ua.browser) && 
  !/wea_link_keep_ebAgentKey/.test(window.location.href)) { 
  weappSDK?.ready(() => { 
    if (window.ebCurrentTenantKey && window.ebCurrentCorpKey && window.ebCurrentAgentKey) { 
      const href = window.location.href;
      window.history.replaceState(null, '', `${href}${href.indexOf('?') !== -1 ? '&' : '?'}wea_link_keep_ebAgentKey=${window.ebCurrentAgentKey}&wea_link_keep_ebCorpKey=${window.ebCurrentCorpKey}&wea_link_keep_ebTenantKey=${window.ebCurrentTenantKey}`);
    }
  })
}


declare global {
  interface Window {
    [key: string]: any;
  }
}

/**
 *  registerSdkpen 注册window.open 执行云桥sdk方法
 *  unRegisterLarkOpen 飞书环境下 卸载方法
 *  unRegisterDingTalkOpen 钉钉环境下 卸载方法
 *  unRegisterYunZhiJiaOpen 云之家环境下 卸载方法
 */
export { registerSdkpen, unRegisterLarkOpen, unRegisterDingTalkOpen, unRegisterYunZhiJiaOpen };

export {
  b64EncodeUnicode,
  b64DecodeUnicode,
} from './tools/b64encode';

export {
  getReactPlugin,
  regReactPlugin,
} from './tools/react-plugin';

export {
  classUseMemo,
} from './tools/classHooks';

export type {
  HookType,
  QueueType,
  ReadyStateType,
  ReadyCallbackType,
} from './tools/js-api-tools';

export {
  overwriteFn,
  regReactChildren,
  eventEmitter,
  regHook,
  setHooks,
  getHooks,
  unRegHook,
  getSyncHook,
  getAsyncHook,
  getPromiseHook,
  regReadyHook,
  getReadyState,
  getReadySuccessHook,
  getReadyFailedHook,
} from './tools/js-api-tools';

export {
  getHistoryPlugin,
  regHistoryPlugin,
} from './tools/history-plugin';

export {
  default as request,
  qs,
  getNameFromUrl,
  prefixSecondPath,
} from './tools/request';

export { doSensitiveScan } from './tools/request/sensitiveScan';

export {
  default as appInfo,
} from './tools/appInfo';

export {
  default as corsImport,
} from './tools/corsImport';

export {
  default as WeappSDK,
  weappSDK,
} from './tools/sdk';

export { default as weappConfig, baseConfigInstance } from './tools/baseConfig'


export {
  default as copy,
} from './tools/copy';

export {
  middleware,
  regOvComponent,
  regOvProps,
  unRegOvComponent,
  unRegOvProps,
  getOverwrite
} from './tools/middleware';

// 抛出性能监控的公共方法
export {
  default as weappMonitorInstance,
} from './tools/monitor';

// 抛出日期时间组件全局方法
export {
  //日期切割
  getDateArrayFromString,
  //时区与格式转换
  getLocaleDate,
  getServerDate,
  getLocaleDateTime,
  getServerDateTime,
  getLocaleDateAndTime,
  getServerDateAndTime,
  getLocaleDateString,
  getServerDateString,
  //格式获取与转换
  getDateTimeFormat,
  getWindowDateShowFormat,
  getWindowDateTimeShowFormat,
  getCustomFormatByWindow,
  getCustomFormatDateByWindow,
  getValidDateFromCustomFormat,
  getCorrectDateByLocale,
  //周工具方法
  getWeekOfYear,
  getWeekBoundary,
  //季度工具方法
  getSeasonDateByYear,
  //半年工具方法
  getHalYearByYear,
  //年份工具方法
  getCurrentUpYear,
  //时间工具方法
  isZeroClock,
  isStrDateContainHMS,
  //时区计算工具方法
  getUserOffsetName,
  isStrDateContainUTC,
  //日期校验
  isDate,
  getDateTestReg,
} from './tools/dateFormat';


export { default as classnames } from 'classnames';

export { default as camelcase } from 'camelcase';

// 注册性能监控的实例
weappMonitorInstance.initMonitor();

let bodyInstance: any = null;

export const loadFastClick = () => import(
  /* webpackPrefetch: 'mobile' */
  /* webpackChunkName: "fastclick" */
  './tools/fastclick'
).then(m => {
  if (ua.device !== 'PC' && (
    !bodyInstance || (bodyInstance && !bodyInstance.layer)
  )) {
    bodyInstance = m.default.attach(document.body);
  }
  return {
    FastClick: m.default,
    bodyInstance,
  }
});

// 移动端加载FastClick
if (ua.device !== 'PC') {
  loadFastClick()
}

export { getLabel, getLocale, getMoney, getLocaleThousands, getUnifiedNumber, getCurrencyName, getLang, getExchangeConverter } from './tools/locale';

export type { RequestOptionConfig, RequestPromise, RequestResult } from './tools/request';

export { default as validator } from './tools/validator';

export { default as dayjs } from './tools/dayjs';

export type { MoudleDialogType, ModulePath, ModuleSign, ModuleSignMap } from './tools/moduleRouter/types';

export { default as moduleRouter } from './tools/moduleRouter';

export { moduleSignToModule } from './tools/moduleRouter/routes';

export type { ErrorBoundaryProps } from './tools/errorBoundary';

export { default as ErrorBoundary } from './tools/errorBoundary';

export { checkWeId, getRenderDuring, ReactUtils } from './tools/reactUtils';

export type { UAType };

export { ua, setTheme, replaceCss, setTitle, vconsole, documentTitle, history, historyUtil, ALink, ALinkIntercept, needConvertWechatData, sparkMD5, setFontSize, needRTL, setRTL };

const formatCanvasData = (arr: any[]) => {
  return arr.map((item: any) => {
    const arr = item.slice(1, -1).split('=');
    return { type: arr[0], id: arr[1] };
  })
}

export function convertWechatData(optionNames: Array<any>) {
  return new Promise((rs, rj) => {
    try {
      const patt = /^\$\S+=\S+\$$/;
      const needConvertArr = formatCanvasData(optionNames.filter((d) => patt.test(d)));
      if (needConvertArr.length === 0) {
        rs(optionNames);
        return;
      }

      // no.2297953 修复convertWechatData方法在pc直接登录时padding无返回问题
      if (weappSDK && !weappSDK.customSDK) {
        rs(optionNames);
        return;
      }

      weappSDK && weappSDK.customSDK && weappSDK.checkApi("convertWWOpenDataCanvas").then((data: any) => {
        weappSDK.exec('convertWWOpenDataCanvas', {
          tenantKey: window.TEAMS?.currentTenant?.tenantKey,
          items: needConvertArr
        }).then((res: any) => {
          const result = optionNames.map((r) => {
            if (patt.test(r)) {
              let d = { data: "" };
              d = res.items.find((_r: any) => r.indexOf(_r.id) > -1)
              return d ? d.data : r;
            } else {
              return r;
            }
          })
          rs(result);
        }, () => {
          rs(optionNames);
        });
      })
    } catch (e) {
      rs(optionNames);
    }
  })
}

/**
 * 统一处理pc、h5路由跳转
 * @param getPath 获取需要跳转的路由，如果函数返回为空，表示不需要跳转路由
 */
export function shouldRouteJump(getPath: (ua: UAType, url: string) => string | null | undefined | void) {
  // 处理全局开关
  const globalEnable = true;
  if (globalEnable) {
    try {
      const newUrl = getPath(ua, window.location.href);
      // 如果返回地址为空或者与原先地址相同则不做跳转
      if (!newUrl || newUrl === window.location.href) return;
      const jump = () => {
        window.location.replace(newUrl);
      };
      jump();
    } catch (error) {
      console.error(`Error: pc、h5路由地址映射跳转异常！`);
      console.error(error);
    }
    // 处理统一弹框提示
    // if (ua.device === 'PC' && window.weappUi?.Dialog?.confirm) {
    //   window.weappUi.Dialog.confirm({
    //     mask: true,
    //     content: '确定跳转页面？',
    //     onOk: jump
    //   });
    // } else if (ua.device !== 'pc' && window.weappUi?.MDialog?.prompt) {
    //   window.weappUi.MDialog.prompt({
    //     mask: true,
    //     message: "确定跳转页面？",
    //     prompt: false,
    //     onOk: jump
    //   });
    // } else {
    //   jump();
    // }
  }
}
export {
  successBatchTip,
  failureBatchTip,
  registerTip
}


// registerTip();

export { webOpenSDK, getSecondPathUrl, handleSecondPath } from './tools/open';

export {
  whiteListSdk
} from './tools/a-link/whitelist';

export {
  replaceWechatStr
} from './tools/document-title'


/* 版本导出 */
export { default as version } from './libVersion';

export { default as ResizeObserver } from 'resize-observer-polyfill'

export { initPageGrey }